<template>
	<view class="activity-item" @click="$emit('select')">
		<view class="activity-message">
			<image src="@/static/uni.png" mode=""></image>
			<view class="message-container">
				<view class="merchant-title">5澳白Flatwhite</view>
				<view class="activity-option">￥26</view>
				<view class="bottom-line">
					<view class="bottom-actions">
						<view class="action del-actions" @click="$emit('editAction')" >编辑</view>
						<view class="action" @click="$emit('deleteAction')" >删除</view>
					</view>
				</view>
			</view>
		</view>
		
	</view>
</template>

<script>
	export default {
		name:"merchantActivityItem",
		props: {
			itme: {
				type: Object,
				default: () => {}
			}
		},
		data() {
			return {
				delActivity() {
					this.$emit('deleteAction')
				}
			};
		}
	}
</script>

<style lang="scss" scoped>
.activity-item {
	background-color: #fff;
	padding: 28rpx 32rpx;
	border-bottom: 10px solid #f7f7f7;
	// height: 200rpx;
	.activity-message {
		display: flex;
		image {
			width: 264rpx;
			height: 175rpx;
			border-radius: 8rpx;
			margin-right: 18rpx;
		}
		.message-container {
			flex: 1;
			.merchant-title {
				height: 30rpx;
				font-size: 30rpx;
				font-weight: 600;
				color: #222222;
				line-height: 30rpx;
			}
			.activity-option {
				margin-top: 30rpx;
				height: 24rpx;
				font-size: 30rpx;
				font-weight: 600;
				color: #D20A0A;
				line-height: 24rpx;
			}
		}
		.activity-status {
			ont-size: 26rpx;
			font-weight: 400;
			color: #D20A0A;
			line-height: 26rpx;
		}
	}
	.bottom-line {
		margin-top: 26rpx;
		display: flex;
		flex-direction: row-reverse;
		justify-content: space-between;
		height: 52rpx;
		font-size: 24rpx;
		font-weight: 400;
		color: #999999;
		line-height: 52rpx;
		.bottom-actions {
			width: 304rpx;
			display: flex;
			flex-direction: row-reverse;
			justify-content: space-between;
			.action {
				width: 144rpx;
				height: 52rpx;
				border-radius: 28rpx;
				border: 2rpx solid #D9D9D9;
				box-sizing: border-box;
				font-size: 26rpx;
				font-weight: 400;
				color: #333333;
				text-align: center;
			}
			.del-actions {
				border: 2rpx solid #D20A0A;
				color: #D20A0A;
			}
			.action-count {
				height: 52rpx;
				border-radius: 28rpx;
				border: 2rpx solid #D9D9D9;
				box-sizing: border-box;
				font-size: 26rpx;
				font-weight: 400;
				color: #333333;
				text-align: center;
				padding: 0 28rpx;
			}
		}
	}
}
</style>